var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedZen0)",
    d: "m17.58 8.003l-1.122 1.738a5 5 0 0 1-3.655 7.186c-1.037.17-2.097 0-3.037-.47l-1.743 1.12a6.846 6.846 0 0 0 10.81-5.02a6.88 6.88 0 0 0-1.254-4.558h.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedZen1)",
    d: "M12.009 15.436a3.44 3.44 0 0 0 3.388-2.823a7.85 7.85 0 0 0-6.244 1.298a3.45 3.45 0 0 0 2.856 1.525"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.707 11.81q.883.001 1.746.19a3.447 3.447 0 0 0-6.746-.992a3.4 3.4 0 0 0-.11 1.456q-.718.527-1.291 1.205a5 5 0 0 1 4.061-6.605a5 5 0 0 1 2.872.484l1.735-1.126A6.846 6.846 0 0 0 5.16 11.52a6.86 6.86 0 0 0 1.327 4.561a8.3 8.3 0 0 1 1.17-1.617a10 10 0 0 1 1.21-1.06a8.2 8.2 0 0 1 4.844-1.593z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "tokenBrandedZen0",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(14.6004 0 0 14.5854 17.244 5.139)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#26DB8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#23D29A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1ABBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#0E9DE5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tokenBrandedZen1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(25.3307 0 0 52.7683 23.658 -15.141)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#23D29A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1ABBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#0E9DE5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZen);
export default __webpack_public_path__ + "static/media/zen.24221d4ad5682e4032ef2290b9185924.svg";
export { ForwardRef as ReactComponent };